import * as tslib_1 from "tslib";
import { CheckboxGroupControl } from "../../../common/controls/checkbox-group-control";
import { Checkbox, Radio } from "@h3/antd-vue";
import { Component, Inject } from "vue-property-decorator";
// 二开开始
import Bus from "@cloudpivot/form/utils/bus";
// 二开结束
let CheckboxGroup = class CheckboxGroup extends CheckboxGroupControl {
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    onChange(value) {
        this.hasBatchImport = false;
        const val = value && value.length > 0 ? value.filter((x) => !!x) : null;
        this.setValue(val);
        super.resetCheckboxOptionDisabled();
    }
    onRadioChange(evt) {
        this.hasBatchImport = false;
        const val = evt.target.value;
        this.setValue(val);
    }
    // 二开开始
    mounted() {
        // this.$nextTick(function() {
        Bus.$on('checkBoxHandleClose', (val) => {
            if (val === false) {
                let data = null;
                this.mySetValue(data, '1');
            }
        });
        Bus.$on('checkBoxClose', (val) => {
            if (val === false) {
                let data = null;
                this.mySetValue(data, '2');
            }
        });
        // })
    }
};
tslib_1.__decorate([
    Inject()
], CheckboxGroup.prototype, "layoutTypeFn", void 0);
CheckboxGroup = tslib_1.__decorate([
    Component({
        name: "checkbox-group",
        components: {
            ARadioGroup: Radio.Group,
            ACheckboxGroup: Checkbox.Group,
        },
    })
], CheckboxGroup);
export default CheckboxGroup;
